import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import {
  Button,
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
} from '@cargomatic/ui';
import CargomaticCollapsibleCard from 'components/v2/CollapsibleCard';
import { Plus } from 'lucide-react';
import EquipmentStore from 'stores/EquipmentStore';
import EquipmentItem from './equipments/EquipmentItem';
import AddEquipmentModal from './AddEquipmentModal';
import OrdersActionCreators from '../../../actions/OrdersActionCreators';
import EquipmentActionCreators from '../../../actions/EquipmentActionCreators';

class EquipmentsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModal: false,
    };
  }

  componentDidMount() {
    EquipmentStore.addChangeListener(this.handleEquipmentStoreChange);
  }

  componentWillUnmount() {
    EquipmentStore.removeChangeListener(this.handleEquipmentStoreChange);
  }

  handleAddEquipment = () => {
    this.setState({ showAddModal: true });
  };

  handleEquipmentStoreChange = () => {
    const equipmentList = EquipmentStore.getEquipment();
    if (!equipmentList || equipmentList.length === 0) {
      return;
    }
    const lastIndex = equipmentList.length - 1;
    const equipment = equipmentList[lastIndex];
    const equipments = this.props.order.equipments || [];

    // equipment already added to the order
    if (equipments.map((eq) => eq._id).includes(equipment._id)) {
      return;
    }
    this.handleEquipmentSelect(equipment);
  };

  handleCreateEquipment = (equipment) =>
    EquipmentActionCreators.addEquipment(equipment);

  handleEquipmentSelect = (equipment) => {
    const equipments = this.props.order.equipments || [];
    // equipment already added to the order
    if (equipments.map((eq) => eq._id).includes(equipment._id)) {
      return;
    }
    OrdersActionCreators.addEquipmentToOrder(
      this.props.order._id,
      equipment._id,
    );
  };

  render() {
    const { order, shipments, t } = this.props;
    return (
      <CargomaticCollapsibleCard
        id="order-equipment-details"
        header={() => (
          <div className="flex items-center gap-3 w-full">
            <span>{t('EQUIPMENT_DETAILS')}</span>
            <Button
              size="sm"
              variant="default"
              onClick={() => this.handleAddEquipment()}
              data-testid="add-equipment-button"
            >
              <Plus className="h-4 w-4 mr-1" strokeWidth={2.5} />
              {titleize(t('ADD'))}
            </Button>
          </div>
        )}
      >
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="whitespace-nowrap">
                  {titleize(t('EQUIPMENT_ID'))}
                </TableHead>
                <TableHead className="whitespace-nowrap">
                  {titleize(t('TYPE'))}
                </TableHead>
                <TableHead className="whitespace-nowrap">
                  {titleize(t('SIZE', { count: 1 }))}
                </TableHead>
                <TableHead className="whitespace-nowrap">
                  {titleize(t('DATE', { count: 2 }))}
                </TableHead>
                <TableHead className="whitespace-nowrap">
                  {titleize(t('ATTACHED_TO_SHIPMENT'))}
                </TableHead>
                <TableHead />
              </TableRow>
            </TableHeader>
            <TableBody>
              {order.equipments.map((eq, idx) => {
                return (
                  <EquipmentItem
                    key={eq.equipment_id + idx}
                    order={order}
                    shipments={shipments}
                    equipment={eq}
                  />
                );
              })}
            </TableBody>
          </Table>
        </div>
        {this.state.showAddModal && (
          <AddEquipmentModal
            show={this.state.showAddModal}
            onClose={() => this.setState({ showAddModal: false })}
            onCreateEquipment={this.handleCreateEquipment}
            onEquipmentSelect={this.handleEquipmentSelect}
          />
        )}
      </CargomaticCollapsibleCard>
    );
  }
}

EquipmentsList.propTypes = {
  order: PropTypes.object,
};

export default withTranslation()(EquipmentsList);
